<div class="flex">
	<div class="data-class" [innerHTML]="data.html"></div>
	<div class="dismiss">
		<button class="button-success" (click)="snackBarRef.dismiss()">Ok</button>
	</div>
</div>
